const comBgLine = (() => {

  let line = document.querySelectorAll('.js-com-svg-line');

  if (line.length > 0) {


    let sW = window.innerWidth;

    let duration = 0
    if (sW > 750) {
      duration = 4000
    } else {
      duration = 2000
    }


    line.forEach(element => {

      // let vivusLine = new Vivus(element, {
      //   type: 'delayed',
      //   duration: 200,
      //   animTimingFunction: Vivus.EASE,
      //   start: 'manual'
      // }, function (obj) {
      //   // console.log("おわた");
      // });

      let lineSvg = Snap(element);
      let lineSvgPath = lineSvg.select('path');


      gsap.to(element, {
        scrollTrigger: {
          trigger: element,
          start: 'top 70%',
          delay: 2,
          onEnter: () => {
            // vivusLine.play();
            lineSvgPath.animate({ 'stroke-dashoffset': 0 }, duration);
          },
          // markers: true,
        }
      });

    });

    // console.log("object");

  }

})();
export default comBgLine;